import React from "react";
import Select from "react-select";

import styles from "./style.module.css";

import { AutoSizer, List } from "react-virtualized";

import NumberFormat from "react-number-format";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faQuestion, faChartBar } from "@fortawesome/free-solid-svg-icons";

import { getFieldRange } from "containers/Predict/reducer";

import { LineInput } from "components/Inputs/LineInput";

import OverlayData from "components/nHotdogChart/OverlayData";

export default class sHotdogChart extends React.PureComponent {
  constructor(props) {
    super(props);

    /*
    if (window.tableau) {
      const markSelection =
        window.tableau.TableauEventType.MarkSelectionChanged;

      window.tableau.extensions.initializeDialogAsync().then(() => {
        const dashboard = window.tableau.extensions.dashboardContent.dashboard;

        for (const worksheet of dashboard.worksheets) {
          const unregisterEventHandlerFunction = worksheet.addEventListener(
            markSelection,
            (selectionEvent) => {
              worksheet.getSelectedMarksAsync().then((marks) => {
                let colName = undefined;
                let index = 0;
                let foundIndex = undefined;

                const fieldNames = props.fieldNames;

                if (
                  fieldNames &&
                  marks.data &&
                  marks.data.length > 0 &&
                  marks.data[0].columns &&
                  marks.data[0].columns.length > 0
                ) {
                  for (const col of marks.data[0].columns) {
                    const tempColName = col.fieldName.replace(" (bin)", "");

                    console.log("www", tempColName);

                    if (fieldNames.indexOf(tempColName) !== -1) {
                      foundIndex = index;

                      console.log("what is this", tempColName);
                      props.updateFieldSelect(tempColName);

                      break;
                    }

                    index++;
                  }

                  if (foundIndex !== undefined) {
                    const valName =
                      marks.data &&
                      marks.data.length > 0 &&
                      marks.data[0].data &&
                      marks.data[0].data.length > 0 &&
                      marks.data[0].data[0].length > 0
                        ? marks.data[0].data[0][foundIndex].value
                        : undefined;

                      console.log("what is this val", valName);

                    if (
                      marks.data &&
                      marks.data.length > 0 &&
                      marks.data[0].data &&
                      marks.data[0].data.length > 0 &&
                      marks.data[0].data.length < 5 &&
                      marks.data[0].data[0].length > 1
                    ) {
                      if (valName !== undefined) {
                        if (
                          props.selectedDataset &&
                          props.selectedDataset.fields &&
                          props.selectedDataset.fields[colName] &&
                          props.selectedDataset.fields[colName].type ===
                            "categorical"
                        ) {
                          if (
                            props.selectedDataset.fields[colName].data
                              .map((v) => v.value)
                              .indexOf(valName) !== -1
                          ) {
                            props.updateValueSelect(valName);
                          }
                        } else {
                          props.updateValueSelect(undefined);
                        }
                      }
                    } else {
                      props.updateValueSelect(undefined);
                    }
                  }
                }
              });
            }
          );
        }
      });
    }
    */
  }
  render() {
    const {
      bars,
      min,
      max,
      model,
      totalLabel,
      showTotalVal,
      colSelections,
      selected,
      isStacked,
      valueSelect,
      updateValueSelect,
      pointerEvents,
      updateFieldOption,
      updateHoverValue,
      hoverValue,
      isProjectOverview,
      handleSelect,
      isTabMini,
      rowCount,
      fields,
      fieldValueCounts,
      outcome,
      predictMode,
      onClick,
      isSmall,
      isContinuous,
      isQuickRun,
      ignored,
      isHideSelect,
      ignoredValue,
      isNotMini,
      isNext,
      showColumnSelect,
      isNoInteractions
    } = this.props;

    const colors = ["#92cf48", "#eb332b", "#b1d36f", "#d7a4aa", "var(--aible-color)"];

    let minH = min
      ? min
      : Math.min.apply(
          null,
          bars.map((b) => b.left)
        );
    let maxH = max
      ? max
      : Math.max.apply(
          null,
          bars.map((b) => b.left)
        ) * (predictMode === "predict" || isHideSelect ? 2.5 : 1.8);

    let hasNeg = false;

    bars &&
      bars[0] &&
      bars[0].values &&
      Object.keys(bars[0].values).forEach((v) => {
        if (bars[0].values[v] < 0) {
          hasNeg = true;
        }
      });

    let current = 0;

    let totalDelta = hasNeg ? maxH : 2 * maxH;

    let rBars = [];
    let rCurrent = 0;
    let tCurrent = 0;
    let index = 0;

    for (const bar of bars) {
      const start = Math.min(rCurrent, rCurrent + bar.left);
      const end = Math.max(rCurrent, rCurrent + bar.left);

      rBars[index] = {
        ...bar,
        value: bar.left,
        totalSubValues: Object.keys(bar.values)
          .map((v) => Math.abs(bar.values[v]))
          .reduce((a, b) => a + b, 0),
        marginLeft: bar.left < 0 ? "calc(" + (50 - ((end - start) / totalDelta) * 100) + "%" + " + 1px)" : "50%",
        width: (end - start) / totalDelta,
        tooltip: [{ value: bar.left, count: bar.count }],
        color: selected === bar.label ? "#71a1e1" : bar.left > 0 ? "rgba(125, 105, 215, 1)" : "rgba(213, 107, 39, 1)",
        isIgnored:
          ignored && bar.label
            ? ignored[bar.label] ||
              ignored[bar.label.replace("_weekday", "")] ||
              ignored[bar.label.replace("_month", "")] ||
              ignored[bar.label.replace("_day", "")]
            : false
      };

      if (bar.isHidden !== true) {
        tCurrent += bar.left;
      }

      rCurrent += bar.left;

      if (Object.keys(rBars[index].values).length === 0) {
        rBars[index].values = {
          [rBars[index].label]: 1
        };
      }

      rBars[index].width;
      index++;
    }
    return (
      <div className={styles.hotdog} id="featureChart" style={isProjectOverview ? { height: "100%" } : {}}>
        <div
          className={
            styles.valueMatrixHolder +
            " " +
            (isSmall && pointerEvents !== true ? styles.valueMatrixSmall : "") +
            " " +
            (pointerEvents ? styles.valueMatrixPointer : "")
          }
        >
          <AutoSizer>
            {({ height, width }) => (
              <List
                rowRenderer={({ index, style }) => {
                  if (index >= rBars.length) {
                    return (
                      <div
                        style={{
                          ...style,
                          height: "62px"
                        }}
                        key={index}
                      />
                    );
                  }

                  const bar = rBars[index];

                  return (
                    <HotdogBar
                      isNotMini={isNotMini}
                      bar={bar}
                      index={index}
                      key={index}
                      isSelected={selected === bar.label}
                      handleSelect={handleSelect}
                      valueSelect={valueSelect}
                      selected={selected}
                      showColumnSelect={showColumnSelect}
                      updateValueSelect={updateValueSelect}
                      updateHoverValue={(val) => updateHoverValue(val)}
                      fields={fields}
                      fieldValueCounts={fieldValueCounts}
                      ignoredValue={ignoredValue}
                      predictMode={predictMode}
                      colSelections={colSelections}
                      updateFieldOption={(field, option) => updateFieldOption(field, option)}
                      style={style}
                      showBars={model && model.hasFeatures}
                      hoverValue={hoverValue && bar.label === hoverValue.field ? hoverValue : undefined}
                      baseline={
                        model && model.features && model.features.comparison_mean !== undefined
                          ? model.features.comparison_mean
                          : undefined
                      }
                      outcome={outcome}
                      isContinuous={isContinuous}
                      isQuickRun={isQuickRun}
                      onClick={onClick ? (val) => onClick(val) : undefined}
                      isTabMini={isTabMini}
                      isProjectOverview={isProjectOverview}
                      rowCount={rowCount}
                      isNext={isNext}
                      isNoInteractions={isNoInteractions}
                    />
                  );
                }}
                rowCount={isSmall ? rBars.length : rBars.length + 3}
                rowHeight={62}
                height={height}
                width={width}
                style={{ outline: "none" }}
              />
            )}
          </AutoSizer>
        </div>
        {/*
        <div
          className={styles.zero}
          style={{
            marginLeft: "calc(50% - 21px)"
          }}
        />
        */}
      </div>
    );
  }
}

class HotdogBar extends React.PureComponent {
  state = {
    valueHover: undefined
  };

  normalize(val, max, min) {
    return ((val - min) / (max - min)) * 100;
  }

  attemptSelect(field, values) {
    const dashboard = window.tableau.extensions.dashboardContent.dashboard;

    for (const worksheet of dashboard.worksheets) {
      worksheet
        .selectMarksByValueAsync([{ fieldName: field, value: values }], "select-replace")
        .then((d) => console.log(d));
    }
  }

  handleTableau(bar) {
    const { handleSelect, updateValueSelect, onClick } = this.props;

    if (window.tableau) {
      window.tableau.extensions.initializeDialogAsync().then(() => {
        const field = bar.label;
        const values = Object.keys(bar.values);

        this.attemptSelect(field, values);
      });
    }

    updateValueSelect(undefined);

    if (handleSelect) {
      return handleSelect(bar.label);
    }

    onClick && onClick();

    return Promise.resolve();
  }

  handleValueSelect(field, value) {
    const { updateValueSelect, fields, onClick } = this.props;

    if (window.tableau && fields && fields[field] && fields[field].type === "number") {
      const valRange = value.replace("(", "").replace("]", "").replace(" ", "").split(",");

      window.tableau.extensions.initializeDialogAsync().then(() => {
        this.attemptSelect(field, {
          min: Number(valRange[0]),
          max: Number(valRange[1])
        });

        this.attemptSelect(field + " (bin", {
          min: Number(valRange[0]),
          max: Number(valRange[1])
        });
      });
    } else {
      if (window.tableau) {
        window.tableau.extensions.initializeDialogAsync().then(() => {
          this.attemptSelect(field, [value]);
        });
      }
    }

    updateValueSelect(value);

    onClick && onClick();

    return Promise.resolve();
  }

  getMinMax(label) {
    if (label && label.includes(" to ")) {
      const retRange = getFieldRange(label);
      return retRange;
    } else {
      return {
        label: this.replaceName(label),
        value: label
      };
    }
  }

  replaceName(name) {
    return name === "Blank-Aible"
      ? "I Don't Know"
      : name === "Rare-Value-Aible"
        ? "Rare-Value"
        : name === "@_@Scenario@_@"
          ? "Optimize"
          : name;
  }

  renderFieldSelection() {
    const { bar, fields, predictMode, colSelections, updateFieldOption } = this.props;

    let field = fields && fields[bar.label];

    let options = [
      {
        label: "Optimize",
        value: "@_@Scenario@_@"
      },
      {
        label: "I Don't Know",
        value: "Blank-Aible"
      }
    ];

    if (!field) {
      const optimizeRemoved = options.filter((option) => option.value && option.value !== "@_@Scenario@_@");
      options = optimizeRemoved;
      const deducedField = fields ? Object.keys(fields).filter((key) => bar.label.indexOf(key + "_") > -1) : [];
      field = deducedField.length === 1 && fields[deducedField[0]];
    }

    if (field && field.type !== "number" && bar.values) {
      Object.keys(bar.values).forEach((v) =>
        options.push({
          label: this.replaceName(v),
          value: v
        })
      );
    }

    if (field && field.type === "number" && bar.values) {
      Object.keys(bar.values).forEach((v) => {
        options.push(this.getMinMax(v));
      });

      options = options.sort((a, b) => a.min - b.min);
    }

    return (
      <div
        className={styles.dropDown}
        style={predictMode === "predict" ? { width: "30%", overflow: "visible" } : { width: "0%", overflow: "hidden" }}
      >
        {!field && <div className={styles.fSel}>{"(Calculated Field)"}</div>}
        {field && (
          <div className={styles.fSel}>
            {field.type === "number" ? (
              <Select
                styles={{
                  menuList: (provided, state) => ({
                    ...provided,
                    maxHeight: 150
                  })
                }}
                isSearchable={false}
                options={options}
                onChange={(val) => updateFieldOption(bar.label, val.value)}
                value={
                  colSelections && colSelections[bar.label] !== undefined
                    ? options.filter((o) => o.min <= colSelections[bar.label] && o.max >= colSelections[bar.label])
                        .length > 0 && colSelections[bar.label]
                      ? typeof colSelections[bar.label] === "string" && colSelections[bar.label].includes(" to ")
                        ? {
                            label: options.filter(
                              (o) => o.min <= colSelections[bar.label] && o.max >= colSelections[bar.label]
                            )[0].label,
                            value: colSelections[bar.label]
                          }
                        : {
                            label: options.find((option) => option.value === colSelections[bar.label]).label,
                            value: colSelections[bar.label]
                          }
                      : colSelections && colSelections[bar.label]
                        ? colSelections[bar.label] === "Blank-Aible"
                          ? {
                              label: "I Don't Know",
                              value: "Blank-Aible"
                            }
                          : colSelections[bar.label] === "{Missing}"
                            ? {
                                label: "{Missing}",
                                value: "{Missing}"
                              }
                            : {
                                label: "Optimize",
                                value: "@_@Scenario"
                              }
                        : {
                            label: "I Don't Know",
                            value: "Blank-Aible"
                          }
                    : {
                        label: "I Don't Know",
                        value: "Blank-Aible"
                      }
                }
              />
            ) : (
              bar.values && (
                <div style={{ width: "100%" }}>
                  <Select
                    styles={{
                      menuList: (provided, state) => ({
                        ...provided,
                        maxHeight: 150
                      })
                    }}
                    isSearchable={false}
                    options={options}
                    onChange={(val) => updateFieldOption(bar.label, val.value)}
                    value={
                      colSelections && colSelections[bar.label] !== undefined
                        ? {
                            label: this.replaceName(colSelections[bar.label])
                              .toString()
                              .replace("@_@", "")
                              .replace("@_@", ""),
                            value: colSelections[bar.label]
                          }
                        : options.find((option) => option.value && option.value === "Blank-Aible")
                    }
                  />
                </div>
              )
            )}
            {colSelections && colSelections[bar.label] === "@_@Scenario@_@" && (
              <div className={styles.sIcon} style={{ left: "-34px" }}>
                <FontAwesomeIcon icon={faChartBar} />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      bar,
      index,
      isContinuous,
      isQuickRun,
      model,
      outcome,
      valueSelect,
      handleSelect,
      isTabMini,
      rowCount,
      isSelected,
      isProjectOverview,
      updateValueSelect,
      colSelections,
      ignoredValue,
      predictMode,
      updateFieldOption,
      updateHoverValue,
      fields,
      fieldValueCounts,
      hoverValue,
      showBars,
      baseline,
      style,
      isNotMini,
      hideSelect,
      selected,
      isNext,
      showColumnSelect,
      isNoInteractions
    } = this.props;
    const { valueHover } = this.state;

    const field = fields && fields[bar.label] ? fields[bar.label] : undefined;

    const isBlank =
      predictMode === "predict" &&
      colSelections &&
      colSelections[bar.label] &&
      colSelections[bar.label] === "I Don't Know";

    const isScenario =
      predictMode === "predict" &&
      colSelections &&
      colSelections[bar.label] &&
      colSelections[bar.label] === "@_@Scenario@_@";

    const isDriverColumnSelected = predictMode === "drivers" && showColumnSelect && selected === bar?.label;

    return (
      <div
        id={bar.label}
        className={styles.field}
        style={{
          ...style,
          opacity: bar.isIgnored ? 0.3 : 1.0,
          background: isNoInteractions
            ? "transparent"
            : isDriverColumnSelected
              ? "#D8D3F0"
              : isBlank
                ? "#78619045"
                : isScenario
                  ? "rgba(146, 207, 72, 0.2)"
                  : "transparent"
        }}
      >
        <OverlayTrigger
          key={index}
          placement="top"
          trigger={["hover", "focus"]}
          overlay={
            <Popover id="chart-overlay">
              <OverlayData
                bar={bar}
                valueHover={valueHover}
                baseline={baseline}
                isContinuous={isContinuous}
                outcome={outcome}
                isQuickRun={isQuickRun}
                field={field}
                fieldValueCounts={fieldValueCounts}
                rowCount={rowCount}
              />
            </Popover>
          }
        >
          {showBars === false ? (
            <div className={styles.hideBarLabel}>{bar.label}</div>
          ) : bar && bar.value < 0.25 ? (
            <div
              className={styles.fieldHolder}
              style={{
                width: predictMode === "predict" && isProjectOverview !== true ? "70%" : "100%",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                height: "100%"
              }}
            >
              <div className={styles.newBarLabel} onClick={() => this.handleTableau(bar)}>
                {bar.label}
              </div>
              <div
                className={styles.bHolder}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    backgroundColor: "rgb(81, 47, 119)",
                    width: "1px",
                    height: "100%"
                  }}
                ></div>
              </div>
            </div>
          ) : (
            <div
              className={styles.fieldHolder}
              style={{
                width: predictMode === "predict" && isProjectOverview !== true ? "70%" : "100%"
              }}
            >
              <div className={styles.newBarLabel} onClick={() => this.handleTableau(bar)}>
                {bar.label}
              </div>
              <div
                className={styles.bHolder}
                onClick={() => isNotMini && isTabMini !== true && handleSelect(bar.label)}
              >
                {field && field.type !== "number" && predictMode === "predict" && false && (
                  <div
                    className={styles.minus}
                    title="Minimize"
                    onMouseEnter={() =>
                      this.setState({
                        valueHover: {
                          extra: "Click to Minimize"
                        }
                      })
                    }
                    onClick={() => updateFieldOption(bar.label, "@_@Minimize@_@")}
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </div>
                )}
                {field && field.type !== "number" && predictMode === "predict" && false && (
                  <div
                    className={styles.plus}
                    title="Maximize"
                    onMouseEnter={() =>
                      this.setState({
                        valueHover: {
                          extra: "Click to Maximize"
                        }
                      })
                    }
                    onClick={() => updateFieldOption(bar.label, "@_@Maximize@_@")}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </div>
                )}
                {Object.keys(bar.values)
                  .map((v, index) => bar.values[v])
                  .sort((a, b) => b - a)
                  .map((v, i) => {
                    const prevWidth =
                      Object.keys(bar.values)
                        .map((p) => bar.values[p])
                        .sort((a, b) => b - a)
                        .filter((pv, pi) => pi < i)
                        .map((v) => (Math.abs(v) / bar.totalSubValues) * bar.width)
                        .reduce((a, b) => a + b, 0) + 0.5;

                    const prevNegValues = Object.keys(bar.values)
                      .map((p) => bar.values[p])
                      .sort((a, b) => b - a)
                      .filter((pv, pi) => pi >= i && pv < 0)
                      .map((v) => (Math.abs(v) / bar.totalSubValues) * bar.width * 100)
                      .reduce((a, b) => a + b, 0);

                    const prevNegValuesLength = Object.keys(bar.values)
                      .map((p) => bar.values[p])
                      .sort((a, b) => b - a)
                      .filter((pv, pi) => pi >= i && pv < 0).length;

                    const vLength = Object.keys(bar.values).length;

                    const rIndex = vLength > 0 ? (v < 0 ? 1 - (vLength - i) / vLength : 1 - i / vLength) : 1;

                    const sortedValues = Object.keys(bar.values)
                      .map((p) => ({
                        value: bar.values[p],
                        label: p
                      }))
                      .sort((a, b) => b.value - a.value);

                    const width = bar.totalSubValues !== 0 ? (Math.abs(v) / bar.totalSubValues) * bar.width * 100 : 0;

                    let nOffset = 0;
                    for (var n = 0; n < sortedValues.filter((v) => v.value < 0).length; n++) {
                      nOffset += n;
                    }

                    const isIgnored =
                      ignoredValue && ignoredValue[bar.label]
                        ? ignoredValue[bar.label][sortedValues[i].label] === true
                        : false;

                    let isValSelected =
                      (predictMode === "drivers" && valueSelect === sortedValues[i].label && isSelected) ||
                      (predictMode === "predict" &&
                        colSelections &&
                        colSelections[bar.label] !== undefined &&
                        colSelections[bar.label] === sortedValues[i].label);

                    let isColSelected = Object.keys(bar.values).some((b, cIndex) => {
                      let isColSelected =
                        (predictMode === "drivers" && valueSelect === sortedValues[cIndex].label && isSelected) ||
                        (predictMode === "predict" &&
                          colSelections &&
                          colSelections[bar.label] !== undefined &&
                          colSelections[bar.label] === sortedValues[cIndex].label);

                      if (hoverValue && sortedValues[cIndex].label === hoverValue.value) {
                        isColSelected = true;
                      }

                      let avgNum = undefined;

                      if (predictMode === "predict") {
                        if (field && field.type === "number") {
                          if (sortedValues[cIndex].label && sortedValues[cIndex].label.indexOf(" to ") !== -1) {
                            const currOption = this.getMinMax(sortedValues[cIndex].label);

                            const min = currOption.min;
                            const max = currOption.max;

                            avgNum = currOption.value;

                            if (
                              colSelections &&
                              colSelections[bar.label] !== undefined &&
                              colSelections[bar.label] >= min &&
                              colSelections[bar.label] <= max &&
                              typeof colSelections[bar.label] !== "string"
                            ) {
                              isColSelected = true;
                            }
                          }
                        } else {
                          if (
                            colSelections &&
                            colSelections[bar.label] === undefined &&
                            sortedValues[cIndex].label === "Blank-Aible"
                          ) {
                            isColSelected = true;
                          }
                        }
                      }

                      return isColSelected;
                    });

                    let isHovered = false;

                    if (hoverValue && sortedValues[i].label === hoverValue.value) {
                      isValSelected = true;
                    }

                    let avgNum = undefined;

                    if (predictMode === "predict") {
                      if (field && field.type === "number") {
                        if (sortedValues[i].label && sortedValues[i].label.indexOf(" to ") !== -1) {
                          const currOption = this.getMinMax(sortedValues[i].label);

                          const min = currOption.min;
                          const max = currOption.max;

                          avgNum = currOption.value;

                          if (
                            colSelections &&
                            colSelections[bar.label] !== undefined &&
                            colSelections[bar.label] >= min &&
                            colSelections[bar.label] <= max &&
                            typeof colSelections[bar.label] !== "string"
                          ) {
                            isValSelected = true;
                          }
                        }
                      } else {
                        if (
                          colSelections &&
                          colSelections[bar.label] === undefined &&
                          sortedValues[i].label === "Blank-Aible"
                        ) {
                          isValSelected = true;
                        }
                      }
                    }

                    if (isNoInteractions) {
                      isValSelected = false;
                      isColSelected = false;
                    }

                    return (
                      <div
                        className={styles.bar}
                        style={{
                          width:
                            bar.totalSubValues !== 0
                              ? (Math.abs(v) / bar.totalSubValues) * bar.width * 100 + "%"
                              : bar.width * 100 + "%",
                          marginLeft:
                            bar.totalSubValues !== 0
                              ? v > 0
                                ? "calc(" + prevWidth * 100 + "% + " + i * 2 + "px)"
                                : "calc(" + (50 - prevNegValues) + "% + " + -prevNegValuesLength + "px)"
                              : bar.marginLeft,
                          background: v < 0 ? "rgba(213, 107, 39, 1)" : "rgba(125, 105, 215, 1)",
                          color: isNext ? "#FFFFFF" : isValSelected || v >= 0 ? "#FFFFFF" : "#4B495B",
                          border: isValSelected ? "0px solid" : v < 0 ? "0px solid" : "0px solid",
                          borderColor: isValSelected ? "#F47C20" : v < 0 ? "#0EA8BD" : "var(--aible-color)",
                          cursor: "default",
                          justifyContent: "left",
                          paddingLeft: width > 8 ? "5px" : "0px",
                          opacity: isIgnored || (isColSelected && !isValSelected) ? 0.3 : 1.0
                        }}
                        onMouseEnter={() => {
                          this.setState({
                            valueHover: sortedValues[i]
                          });
                          updateHoverValue({
                            field: bar.label,
                            value: sortedValues[i]
                          });
                        }}
                        onClick={
                          predictMode === "predict"
                            ? () => {
                                updateFieldOption(bar.label, avgNum !== undefined ? avgNum : sortedValues[i].label);
                                this.handleValueSelect(bar.label, sortedValues[i].label);
                              }
                            : () => this.handleValueSelect(bar.label, sortedValues[i].label)
                        }
                        key={i}
                      >
                        {width > 8 && sortedValues[i].label}
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </OverlayTrigger>
        {isProjectOverview !== true && !hideSelect && this.renderFieldSelection()}
      </div>
    );
  }
}
